"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _gatsby = require("gatsby");

require("./BlogPostNavigation.css");

var _proptypes = require("../../services/proptypes");

var _BlogSearch = _interopRequireDefault(require("./components/BlogSearch/BlogSearch"));

var _BlogPostCard = _interopRequireDefault(require("./components/BlogPostCard"));

var _BlogPostNavigationHeader = _interopRequireDefault(require("./components/BlogPostNavigationHeader"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BlogPostNavigation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(BlogPostNavigation, _React$Component);

  var _super = _createSuper(BlogPostNavigation);

  function BlogPostNavigation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BlogPostNavigation);
    _this = _super.call(this, props);
    _this.state = {
      searchQuery: '',
      searchResults: [],
      searchLoading: false
    };
    _this.onResultSelect = _this.onResultSelect.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSearchChange = _this.onSearchChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2["default"])(BlogPostNavigation, [{
    key: "onResultSelect",
    value: function onResultSelect(e, _ref) {
      var slug = _ref.result.slug;
      (0, _gatsby.navigate)("".concat(slug, "/"));
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(e, _ref2) {
      var _this2 = this;

      var value = _ref2.value;
      this.setState({
        searchQuery: value,
        searchLoading: true
      }, function () {
        var searchResults = _this2.getFilteredPosts();

        _this2.setState({
          searchResults: searchResults,
          searchLoading: false
        });
      });
    }
  }, {
    key: "getFilteredPosts",
    value: function getFilteredPosts() {
      var posts = this.props.posts;
      var searchQuery = this.state.searchQuery;
      var re = new RegExp(searchQuery, 'i');

      var isMatch = function isMatch(text) {
        return re.test(text);
      };

      return posts.filter(function (_ref3) {
        var title = _ref3.title,
            content = _ref3.content,
            summary = _ref3.summary;
        return isMatch(title) || isMatch(summary) || isMatch(content);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          searchQuery = _this$state.searchQuery,
          searchLoading = _this$state.searchLoading,
          searchResults = _this$state.searchResults;
      var _this$props = this.props,
          posts = _this$props.posts,
          title = _this$props.title,
          description = _this$props.description,
          featuredPostId = _this$props.featuredPostId,
          columns = _this$props.columns,
          alwaysShowSearch = _this$props.alwaysShowSearch; // if nothing is being searched, make sure to always display all posts

      var displayablePosts = searchQuery.length === 0 ? posts : searchResults;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "blog-post-navigation"
      }, /*#__PURE__*/_react["default"].createElement(_BlogPostNavigationHeader["default"], {
        posts: posts,
        title: title,
        description: description,
        featuredPostId: featuredPostId
      }), (posts.length > columns - 1 || alwaysShowSearch) && /*#__PURE__*/_react["default"].createElement(_BlogSearch["default"], {
        value: searchQuery,
        onResultSelect: this.onResultSelect,
        onSearchChange: this.onSearchChange,
        searchResults: searchResults,
        loading: searchLoading
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        stackable: true,
        columns: columns,
        className: "blog-cards"
      }, displayablePosts.map(function (post) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: post.title
        }, /*#__PURE__*/_react["default"].createElement(_BlogPostCard["default"], post));
      }), displayablePosts.length === 0 && /*#__PURE__*/_react["default"].createElement("p", null, " No posts found ")));
    }
  }]);
  return BlogPostNavigation;
}(_react["default"].Component);

exports["default"] = BlogPostNavigation;
BlogPostNavigation.propTypes = {
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  featuredPostId: _propTypes["default"].number,
  columns: _propTypes["default"].number,
  alwaysShowSearch: _propTypes["default"].bool,
  posts: _propTypes["default"].arrayOf(_proptypes.BlogPostPropType).isRequired
};
BlogPostNavigation.defaultProps = {
  title: 'Blog',
  description: '',
  columns: 4,
  alwaysShowSearch: true,
  featuredPostId: null
};